import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityTiposTecnicoLoadFailure,
  entityTiposTecnicoLoadSuccess,
  entityTiposTecnicoLoadRequest
} from './entity-tipos-tecnico.actions';
import { TiposTecnicoService } from '@rpe/registro-personas-empresas-lib/src/projects';

@Injectable()
export class TiposTecnicoEffects {
  // load
  loadRequestTiposTecnico = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTiposTecnicoLoadRequest),
      mergeMap(() =>
        this.tiposTecnicoServiceService.getTiposTecnico().pipe(
          map((items) => entityTiposTecnicoLoadSuccess({ items })),
          catchError((error) => of(entityTiposTecnicoLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private tiposTecnicoServiceService: TiposTecnicoService
  ) {
    this.tiposTecnicoServiceService.url = environment.apiUrl;
  }
}
